export type RemainingSecondsInput = {
	expiresAt: number;
	now?: number;
};

export const remainingSeconds = ({ expiresAt, now = Date.now() }: RemainingSecondsInput): number =>
	Math.max(0, Math.ceil((expiresAt - now) / 1000));

export const formatCountdown = (seconds: number): string => {
	if (seconds < 60) return `${seconds}s`;
	const minutes = Math.floor(seconds / 60);
	const rest = seconds % 60;
	return `${minutes}:${String(rest).padStart(2, '0')}`;
};
